import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/2/23/US_one_dollar_bill%2C_obverse%2C_series_2009.jpg"
        alt="US one dollar bill"
        className="center-image"
      />
      <p className="message">HI there...</p>
    </div>
  );
}

export default App;
